import React from "react";
import { Card, Row, Col, Typography } from "antd";
import { FaStamp, FaGift } from "react-icons/fa";

const { Title } = Typography;

const ClientStatistics = ({ statistics, isLoading }) => {
  const stats = [
    {
      icon: <FaStamp className="feature-icon" />,
      title: "Toplam Damga",
      value: statistics?.stampCount || 0,
    },
    {
      icon: <FaGift className="feature-icon" />,
      title: "Toplam Ödül",
      value: statistics?.rewardCount || 0,
    },
  ];

  return (
    <Card
      title="Müşteri İstatistikleri"
      type="inner"
      style={{ marginBottom: "24px" }}>
      <Row gutter={[24, 24]}>
        {stats.map((stat, index) => (
          <Col xs={24} sm={24} md={12} lg={12} key={index}>
            <Card
              loading={isLoading}
              style={{
                textAlign: "center",
                height: "100%",
                transition: "all 0.3s ease",
              }}
              hoverable>
              <div
                style={{
                  fontSize: "2.5rem",
                  color: "#1890ff",
                  marginBottom: "16px",
                }}>
                {stat.icon}
              </div>
              <Title level={4}>{stat.title}</Title>
              <Title level={2} style={{ color: "#1890ff" }}>
                {stat.value}
              </Title>
            </Card>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default ClientStatistics;
